// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-y9jn","label":"_2a8G9x","input":"_1K0BJr"};